import React, {createContext, useCallback, useContext, useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {PACKAGE_MANAGER_SOURCE_USER_ITEMS} from "./constants";
import PackageList from "./PackageList";
import {nodeSelector} from "../../state/node/nodeSelectors";
import {showPackageList} from "../../state/package-manager/packageManagerActions";
import {packageManagerSelector} from "../../state/package-manager/packageManagerSelectors";
import "./style.css";

const PackageManagerContext = createContext({
  openPackageManager: () => {}
});

export const usePackageManager = () => useContext(PackageManagerContext);

const PackageManager = ({node, onNavigate, source}) => {
  return <PackageList node={node} onNavigate={onNavigate} source={source} />;
};

export const PackageManagerProvider = ({children}) => {
  const dispatch = useDispatch();

  const nodesConfigNodes = useSelector(state => state?.nodesConfig?.nodes);
  const currentNode = useSelector(nodeSelector);

  const {isPackageListModalVisible, nodeId} = useSelector(packageManagerSelector);

  const [runtimeContext, setRuntimeContext] = useState(null);

  const node = useMemo(() => {
    if (runtimeContext?.source === PACKAGE_MANAGER_SOURCE_USER_ITEMS) {
      return currentNode?.nodeId === nodeId ? currentNode : null;
    }

    return (
      (nodesConfigNodes || []).find(configNode => configNode.nodeId === nodeId) ||
      (currentNode?.nodeId === nodeId ? currentNode : null)
    );
  }, [currentNode, nodeId, nodesConfigNodes, runtimeContext?.source]);

  const openPackageManager = useCallback(
    ({nodeId, nodeCode, readOnly, onNavigate, source}) => {
      setRuntimeContext({
        onNavigate: onNavigate || null,
        source: source || null
      });
      dispatch(showPackageList(nodeId, nodeCode, readOnly));
    },
    [dispatch]
  );

  useEffect(() => {
    if (!isPackageListModalVisible) {
      setRuntimeContext(null);
    }
  }, [isPackageListModalVisible]);

  return (
    <PackageManagerContext.Provider value={{openPackageManager}}>
      {children}
      <PackageManager node={node} onNavigate={runtimeContext?.onNavigate} source={runtimeContext?.source} />
    </PackageManagerContext.Provider>
  );
};

export default PackageManager;
